import { IWorkflow } from "common/interfaces/IWorkflow";
import { TemplateRestService } from "infrastructure/rest/TemplateRestService";

const WORKFLOW_BASE = "/Workflow";
const secureWorkflowRestService = new TemplateRestService(true, WORKFLOW_BASE);

export class WorkflowApi {
    public static async getWorkflows(): Promise<any> {
        const response = await secureWorkflowRestService.get("");
        return response.data;
    }
    public static async saveWorkflow(saveWorkflowRequest: IWorkflow): Promise<any> {
        const response = await secureWorkflowRestService.post("", { workflow: saveWorkflowRequest });
        return response.data;
    }

    public static async updateWorkflow(updateWorkflowRequest: IWorkflow): Promise<any> {
        const response = await secureWorkflowRestService.put("", { workflow: updateWorkflowRequest });
        return response.data;
    }

    public static async getWorkflowById(id: number): Promise<any> {
        const response = await secureWorkflowRestService.get(`/${id}`);
        return response.data;
    }

    public static async deleteWorkflowById(id: number): Promise<any> {
        const response = await secureWorkflowRestService.post("/delete", { workflowId: id });
        return response.data;
    }
}
